



import Vue from "vue";
import MipScreen from "../mip/index.vue";

/**
 * Google Drive labeling.
 *
 * The mapping screen is shared with Microsoft labeling — same Cognni category
 * rail, same mapping rows, same integrations-manager endpoints — so this is a
 * thin route component that renders it with the provider switched. Its own
 * component rather than a second route onto the MIP one so that navigating
 * between the two Configurations entries mounts a fresh screen instead of
 * patching the existing instance in place.
 *
 * Everything provider-specific lives in views/customize/mip/data/provider.ts.
 */
export default Vue.extend({
  components: { MipScreen },
});
